import {StyleSheet} from 'aphrodite';

import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
import {FONT_PROXIMA_14} from 'styles/FontConstants';

import {
  BioentityValueInput,
  BasicFolderItemValueInput,
  MixtureValueInput,
  MoleculeValueInput,
  ProteinValueInput,
  SequenceValueInput,
} from './BioentityValueInput';
import DateValueInput, {DateTimeValueInput} from './DateValueInput';
import {DropdownValueInput} from './DropdownValueInput';
import EntryValueInput from './EntryValueInput';
import {TeamValueInput, UserValueInput} from './PartyValueInput';
import {BooleanValueInput, DecimalValueInput, IntegerValueInput, TextValueInput} from './PrimitiveValueInput';
import {ProcessValueInput, ProcessTaskValueInput} from './ProcessManagementValueInput';
import {
  BoxValueInput,
  ContainerValueInput,
  LocationValueInput,
  PlateValueInput,
  StorableValueInput,
} from './StorableValueInput';
import {ValueInputComponentType} from './ValueInputTypes';

export const DEFAULT_BOOLEAN_FILTER_VALUE_INTERNAL = true;

export const LEAF_TYPE_TO_VALUE_INPUT: {
  [k in LeafType]: ValueInputComponentType<LeafType> | null;
} = {
  [LeafType.BOOLEAN]: BooleanValueInput,
  [LeafType.DATETIME]: DateTimeValueInput,
  [LeafType.DATE]: DateValueInput,
  [LeafType.DECIMAL]: DecimalValueInput,
  [LeafType.INTEGER]: IntegerValueInput,
  [LeafType.JSON]: null,
  [LeafType.TEXT]: TextValueInput,

  [LeafType.BENCHLING_OBJECT]: null,
  [LeafType.BLOB]: null,
  [LeafType.DROPDOWN_OPTION]: DropdownValueInput,
  [LeafType.BATCH]: null,
  [LeafType.BIOENTITY]: BioentityValueInput,
  [LeafType.BASIC_FOLDER_ITEM]: BasicFolderItemValueInput,
  [LeafType.MIXTURE]: MixtureValueInput,
  [LeafType.MOLECULE]: MoleculeValueInput,
  [LeafType.PROTEIN]: ProteinValueInput,
  [LeafType.SEQUENCE]: SequenceValueInput,
  [LeafType.ENTRY]: EntryValueInput,
  [LeafType.PROTOCOL]: null,
  [LeafType.REQUEST]: null,
  [LeafType.RESULT]: null,
  [LeafType.RUN]: null,
  [LeafType.STORABLE]: StorableValueInput,
  [LeafType.BOX]: BoxValueInput,
  [LeafType.CONTAINER]: ContainerValueInput,
  [LeafType.LOCATION]: LocationValueInput,
  [LeafType.PLATE]: PlateValueInput,
  [LeafType.PROCESS]: ProcessValueInput,
  [LeafType.PROCESS_TASK]: ProcessTaskValueInput,
  [LeafType.PROCESS_OUTPUT]: null,
  [LeafType.STUDY]: null, // TODO(BNCH-106639): Implement StudyValueInput
  [LeafType.TEAM]: TeamValueInput,
  [LeafType.TEST_ORDER]: null,
  [LeafType.USER]: UserValueInput,
};

export const BENCHLING_TYPE_INPUT_STYLES = StyleSheet.create({
  primitiveValueInput: {
    height: 38,
    ...FONT_PROXIMA_14,
  },
});
